var map = {
	"./mob_alert_partner_gold_x2.png": 593,
	"./mob_alert_partner_platinum_x2.png": 594,
	"./mob_alert_partner_silver_x2.png": 595,
	"./mob_alert_partner_white_x2.png": 596
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 592;